import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, Backdrop, Fade, Typography, Button, TextField, Input, useTheme } from "@mui/material";
import { validatePassword } from "../../../utils/general";
import Alert from "../../layout/Alert";
import { changePassword } from "../../../action/password";
import customConfig from "../../../config";

const modalSx = { display: "flex", alignItems: "center", justifyContent: "center" };
const paperSx = (theme) => ({
  backgroundColor: "#fff",
  borderRadius: 8,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4, 4, 3),
  minWidth: 350,
  outline: "none",
});
const formFieldSx = (theme) => ({ marginBottom: theme.spacing(2) });
const actionsSx = (theme) => ({ display: "flex", justifyContent: "flex-end", gap: theme.spacing(2) });

const ChangePassword = ({ open, onClose, changePassword }) => {
  const theme = useTheme();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!newPassword || !confirmPassword) {
      setError("Please fill both fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    const { valid, error: validationError } = validatePassword(newPassword);
    if (!valid) {
      setError(validationError);
      return;
    }
    changePassword( newPassword )
      .then(() => {
        setNewPassword("");
        setConfirmPassword("");
        onClose();
    })
    .catch((err) => {
        setError(customConfig.passwordChangeError);
    });
  };

  const handleCancel = () => {
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCancel}
      sx={modalSx}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
    >
      <Fade in={open}>
        <form style={paperSx(theme)} onSubmit={handleSubmit}>
          <Typography variant="h6" gutterBottom>
            Change Password
          </Typography>
          <TextField
            label="New Password"
            type="password"
            fullWidth
            InputProps={{ disableUnderline: true }}
            sx={formFieldSx(theme)}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoFocus
          />
          <TextField
            label="Confirm New Password"
            type="password"
            InputProps={{ disableUnderline: true }}
            fullWidth
            sx={formFieldSx(theme)}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error && (
            <Typography color="error" variant="body2" sx={formFieldSx(theme)}>
              {error}
            </Typography>
          )}
          <div style={actionsSx(theme)}>
            <Button onClick={handleCancel} color="secondary">
              Cancel
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Submit
            </Button>
          </div>
        </form>
      </Fade>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => ({
  changePassword: (newPassword) => dispatch(changePassword(newPassword)),
});

export default connect(null, mapDispatchToProps)(ChangePassword);
